/* eslint-disable @typescript-eslint/ban-types */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { IconButton, } from '@mui/material';
import { Handle, Position } from '@xyflow/react';
import { ExecutionPlan } from './ExecutionPlan';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import './ParameterNode.css'
import { IconWithTooltip } from '../../../globalUtils/globalIcons';
import { SidePopover } from '../../../globalUtils/globalExports';
import ScheduleExecutionSidePopover from './ScheduleExecutionSidePopover';
import { ScheduleExecution } from '../../../rmsReduxStore/ruleEngineRedux/ruleEngineType';
import { cloneDeep } from 'lodash';
import { formatDateForHistory } from '../../../globalUtils/globalHooks';
import './ScheduleTimeNode.css'
// import { Dayjs } from 'dayjs';

interface ScheduleTimeNodeProps {
    data: {
        label?: string;
        executionPlan: ExecutionPlan;
        handleUpdateExecutionPlan: Function;
        removeNode: Function
    };
}

const ScheduleTimeNode: React.FC<ScheduleTimeNodeProps> = (props) => {

    const { executionPlan, handleUpdateExecutionPlan, removeNode } = props.data;
    const [isScheduleTimePopOverOpen, setIsScheduleTimePopOverOpen] = useState(false);

    const handleEdit = () => {
        setIsScheduleTimePopOverOpen(true);
    }

    const handleCloseScheduleTimePopOver = () => {
        setIsScheduleTimePopOverOpen(false);
    }

    const [scheduleTimeData, setScheduleTimeData] = useState<ScheduleExecution>({
        scheduleType: '',
        dateTime: null,
        recurrenceDays: null,
        recurrenceRange: null,
        recurrenceCount: null,
        endDate: null,
    });

    useEffect(() => {
        const data = cloneDeep(executionPlan.scheduleTime);
        const currentScheduleTimeData = cloneDeep(scheduleTimeData);
        currentScheduleTimeData.scheduleType = data.scheduleType ?? '';
        currentScheduleTimeData.dateTime = data.dateTime ?? null;
        currentScheduleTimeData.recurrenceDays = data.recurrenceDays;
        currentScheduleTimeData.recurrenceRange = data.recurrenceRange;
        currentScheduleTimeData.recurrenceCount = data.recurrenceCount;
        currentScheduleTimeData.endDate = data.endDate;
        setScheduleTimeData(currentScheduleTimeData);
    }, [executionPlan])

    const getRecurrenceSelectedTime = (time) => {
        const givenRecurrenceDate = new Date(time);
        if (givenRecurrenceDate && time) {
            return new Intl.DateTimeFormat('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            }).format(givenRecurrenceDate);
        }
    }

    const order = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
    const sortWeekdays = (unsortedWeekdays: string[]) => {
        return unsortedWeekdays.sort((a, b) => order.indexOf(a) - order.indexOf(b));
    }

    return (
        <>
            <Box
                sx={{
                    minWidth: 300,
                    height: 160,
                    border: '1px solid #00BFBF',
                    borderRadius: '12px',
                    padding: 2,
                    backgroundColor: '#fff',
                    borderLeft: '7px solid #00BFBF '
                }}>
                <Handle type="source" position={Position.Bottom} className='advance__rule__engine__transparent-handle'
                />
                <Handle type="source" position={Position.Left} className='advance__rule__engine__transparent-handle' id='left'  // Adjust left as needed
                />
                {/* Title with icon */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <IconWithTooltip iconClassName={'define_execution__bolt_black__icon'} />
                    <Typography sx={{ fontWeight: '500', fontSize: '15px', marginBottom: '5px' }}>Trigger</Typography>
                    <IconButton
                        size="small"
                        onClick={() => { }}
                        sx={{
                            position: 'absolute',
                            right: '8px',
                            top: '8px',
                        }}
                    >
                        <CloseIcon
                            onClick={() => removeNode()}
                            fontSize="small"
                            sx={{ color: '#666' }} />
                    </IconButton>
                </Box>


                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Typography sx={{ fontSize: 14, mr: 1 }}>in</Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '4px 8px',
                            backgroundColor: '#f9f9f9',
                            flex: 1,
                            gap: '8px'
                        }}
                    >
                        <IconWithTooltip iconClassName={'scheduleTime-sidebar'} />

                        <Typography sx={{ fontSize: 14 }}>Schedule Time</Typography>
                    </Box>

                </Box>
                <div style={{ display: 'flex', gap: '6px' }}>
                    <IconWithTooltip iconClassName={'rule__engine__form__schedule__execution__icon'} />
                    <Typography sx={{ fontWeight: '500', fontSize: '14px', marginBottom: '5px' }}>When</Typography>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '35px', backgroundColor: '#EEFFFF', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {props?.data?.executionPlan ? (
                            scheduleTimeData && scheduleTimeData?.scheduleType  && (
                                <>
                                    <div className='advance__rule__engine__schedule__time__node_content__wrapper'>
                                        <div className='advance__rule__engine__schedule__time__node_content__wrapper'>
                                            <div className='advance__rule__engine__schedule__time__node__subHeading__label'> {scheduleTimeData.scheduleType === 'OneTime' ? 'One Time:' : 'Recurring :'}</div>
                                            <div className='advance__rule__engine__schedule__time__node__subHeading__label__value'>{scheduleTimeData.scheduleType === 'OneTime' ? formatDateForHistory(scheduleTimeData.dateTime) : scheduleTimeData.dateTime === null ? '' : `At ${scheduleTimeData.dateTime && getRecurrenceSelectedTime(scheduleTimeData.dateTime.toLocaleString())}`}</div>
                                        </div>
                                        {
                                        scheduleTimeData?.scheduleType === 'Recurring' && scheduleTimeData.recurrenceDays && <div className='advance__rule__engine__schedule__time__node_content__wrapper'>
                                            <div className='advance__rule__engine__schedule__time__node__subHeading__label'>On :</div><div className='advance__rule__engine__schedule__time__node__subHeading__label__value'>{scheduleTimeData.recurrenceDays && sortWeekdays(scheduleTimeData.recurrenceDays).join(',')}</div>
                                        </div>
                                        }
                                    </div>
                                </>
                            )
                        ) : (
                            <span style={{ fontStyle: 'italic', color: 'gray' }}>(Add Schedule)</span>
                        )}
                    </div>
                    <IconButton size="small" onClick={handleEdit}>
                        <EditIcon fontSize="small" sx={{ color: '#666' }} />
                    </IconButton>
                </div>

            </Box>
            {isScheduleTimePopOverOpen && <SidePopover
                id='advance__rule__engine__schedule__time__execution__plan__side__popover'
                open={isScheduleTimePopOverOpen}
                headerText={'Schedule Time'}
                containerClassName='advance__rule__engine__detail__popover'
                handleClose={() => { }}
                popperClassName='advance__rule__engine__trigger__point__side__popover'
                headerClassName={'advance__rule__engine__header__config'}
                horizontalLinePopover={true}
                isRuleEnginePopOver={true}
                headingIconClassName={'scheduleTime-sidebar'}
                ruleEngineSidePopoverOnclose={handleCloseScheduleTimePopOver}
                /*eslint-disable react/no-children-prop*/
                children={
                    <ScheduleExecutionSidePopover
                        handleClose={handleCloseScheduleTimePopOver}
                        scheduleTimeData={scheduleTimeData}
                        executionPlan={executionPlan}
                        handleUpdateExecutionPlan={handleUpdateExecutionPlan}
                    />
                }
            />
            }

        </>

    );
};

export default ScheduleTimeNode;
